import React from "react";
import styled from "styled-components";
import { useAmazonContext } from "../Contexts/AmazonContext";

const StreakContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  color: ${props => props.frozen ? '#3a9bdc' : '#ff6b35'};
  font-family: "Quicksand", sans-serif;
  font-weight: bold;
  cursor: pointer;
  transition: transform 0.2s ease;

  &:hover {
    transform: translateY(-2px);
  }
`;

const FireIcon = styled.div`
  font-size: 20px;
  animation: ${props => props.streak > 0 ? 'flicker 2s infinite' : 'none'};

  @keyframes flicker {
    0%, 100% { transform: scale(1); }
    50% { transform: scale(1.1); }
  }
`;

const FrozenIcon = styled.div`
  font-size: 20px;
  animation: frostSpin 4s ease-in-out infinite;

  @keyframes frostSpin {
    0%, 100% { transform: rotate(0deg) scale(1); }
    50% { transform: rotate(20deg) scale(1.08); }
  }
`;

const StreakNumber = styled.span`
  font-size: 18px;
  font-weight: bold;
  color: ${props => props.frozen ? '#3a9bdc' : '#ff6b35'};
  text-shadow: ${props => props.frozen ? '0 0 6px rgba(91, 192, 255, 0.6)' : 'none'};
`;

const RecoveryBadge = styled.span`
  font-size: 11px;
  font-weight: 800;
  color: #ffffff;
  background: linear-gradient(90deg, #3a9bdc, #5bc0ff);
  padding: 2px 7px;
  border-radius: 999px;
  box-shadow: 0 2px 0 #2878b0;
`;

const StreakDisplay = ({ onClick, showText = true }) => {
  const { currentStreak, streakStatus, streakRecovery, setShowStreakFrozenModal } =
    useAmazonContext();
  const isFrozen = streakStatus === "frozen" && !!streakRecovery;

  if (isFrozen) {
    return (
      <StreakContainer
        frozen
        title="Your streak is frozen. Tap to see how to thaw it."
        onClick={(e) => {
          setShowStreakFrozenModal(true);
          if (onClick) onClick(e);
        }}
      >
        <FrozenIcon>❄️</FrozenIcon>
        <StreakNumber frozen>{currentStreak}</StreakNumber>
        <RecoveryBadge>
          {streakRecovery.lessonsCompleted}/{streakRecovery.lessonsRequired}
        </RecoveryBadge>
      </StreakContainer>
    );
  }

  return (
    <StreakContainer onClick={onClick}>
      <FireIcon streak={currentStreak}>🔥</FireIcon>
      <StreakNumber>{currentStreak}</StreakNumber>
    </StreakContainer>
  );
};

export default StreakDisplay; 
